import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';

export const Hero = () => {
  const CONTACT_URL = "https://paduaweddings.com/#contact";
  const HERO_IMAGE = "https://ik.imagekit.io/aeu02xvjgn/Updated%20images/ChatGPT%20Image%20May%202,%202026,%2007_26_10%20PM.png?updatedAt=1777937947625";

  return (
    <>
      <section className="relative h-[92vh] md:h-[95vh] lg:h-[100vh] flex items-end justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src={HERO_IMAGE} 
            alt="Padua Weddings Estate" 
            className="w-full h-full object-cover object-[50%_35%] md:object-center scale-105"
            loading="eager"
          />
          <div className="absolute inset-0 bg-black/20"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-deep-charcoal/90 via-deep-charcoal/20 to-transparent"></div>
        </div>

        <div className="relative z-20 max-w-[1320px] mx-auto px-6 md:px-12 w-full text-center pb-[8%] md:pb-[10%]">
          <div className="max-w-[860px] mx-auto">
            <motion.div 
              initial={{ opacity: 0, y: 30 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ duration: 1, ease: "easeOut" }}
            >
              <span className="inline-block py-1.5 px-4 rounded-full border border-white/30 text-white text-[10px] md:text-xs font-semibold tracking-[0.2em] uppercase mb-6 bg-white/10 backdrop-blur-md">
                Wedding Planning & Estimate Guide
              </span>
              <h1 className="font-serif text-[clamp(2.4rem,8vw,5.5rem)] text-white leading-[1] md:leading-[1.1] mb-6 drop-shadow-xl">
                Padua Weddings <br className="hidden md:block" /> 
                <span className="text-warm-stone italic font-light">Master Guide</span>
              </h1>
              <p className="text-base md:text-xl lg:text-2xl text-white/90 font-light mb-10 leading-relaxed max-w-2xl mx-auto drop-shadow-md">
                A curated planning guide for couples exploring Padua’s capacity, event minimums, ceremony options, dining, bar packages, enhancements, and estimate preview.
              </p>
            </motion.div>

            <motion.div 
              initial={{ opacity: 0, y: 20 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
              className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-5"
            >
              <Button href={CONTACT_URL} className="w-full sm:w-auto px-10 py-4 bg-olive-grove text-vintage-white hover:bg-[#5d6344] shadow-2xl font-bold min-h-[52px]">
                Request a Proposal
              </Button>
              <div className="flex w-full sm:w-auto gap-3">
                <Button href="#food" variant="outline" className="flex-1 sm:w-auto px-6 py-4 border-white text-white hover:bg-white hover:text-deep-charcoal min-h-[52px]">
                  View Menu
                </Button>
                <Button href="#bar" variant="outline" className="flex-1 sm:w-auto px-6 py-4 border-white text-white hover:bg-white hover:text-deep-charcoal min-h-[52px]">
                  View Bar Packages
                </Button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="bg-aged-ivory py-12 md:py-16 border-b border-warm-stone/20">
        <div className="max-w-[860px] mx-auto px-6 text-center">
          <p className="text-deep-charcoal/80 text-base md:text-lg font-light font-sans leading-relaxed italic">
            "This guide is designed to help couples understand Padua’s core wedding details before requesting a custom proposal. Final pricing may vary based on date, guest count, menu selections, bar service, ceremony needs, rentals, administrative fee, tax, and event details."
          </p>
          <p className="mt-6 text-estate-bronze text-[11px] uppercase tracking-[0.3em] font-bold">
            Built to help you explore your options
          </p>
        </div>
      </section>
    </>
  );
};